export default __webpack_public_path__ + "static/media/icon_solid_calender.dcdf7034.svg";